import onEnvironmentChange from '@/observables/environment.observable'
import Fingerprint from '@fingerprintjs/fingerprintjs'
import type Environment from '@interfaces/environment.interface'
import MainService from '@services/main/main.service'
import { take } from 'rxjs/operators'

export default class LogService extends MainService {
  localForage: any
  fp: any
  url: string
  environment: Environment
  message: {
    version: string
    name: string
    component: string
    environment: string
  }

  constructor(dareDevilUrl?: string) {
    super()
    this.fp = Fingerprint.load()
    if (!dareDevilUrl) {
      onEnvironmentChange.pipe(take(1)).subscribe((environment: Environment) => {
        this.url = environment?.squidApis?.daredevil
        this.environment = environment
        this.message = {
          version: this.environment?.version,
          name: 'Squid Hub 2.0',
          component: 'Squid Hub 2.0',
          environment: this.environment?.env,
        }
      })
    } else {
      this.url = dareDevilUrl
    }
  }

  public init(componentName = 'Comunidade') {
    this.message.component = componentName
  }

  async log(message: any, type: string) {
    const fingerprint = await (await this.fp)?.get()
    const payload = {
      message: message?.message,
      type,
      request: message?.request,
      fingerprint,
      ...message,
      ...this.message,
    }

    return await fetch(`${this.url}/v1/es/log`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((r) => r.json())
      .then((r) => r.data)
  }

  shouldLog() {
    return !['local', 'test'].includes(this.environment?.env)
  }

  async info(message: { message: string; user?: any; request?: any }) {
    if (this.environment?.env === 'development') {
      // eslint-disable-next-line no-console
      console.log(message)
    }
    if (!this.shouldLog()) {
      return false
    }
    return await this.log(message, 'info')
  }

  async error(message: { message: string; user?: any; request?: any; error?: any }) {
    if (this.environment?.env === 'development') {
      console.error(message)
    }
    if (!this.shouldLog()) {
      return false
    }

    return await this.log(message, 'error')
  }

  async warn(message: { message: string; user?: any; request?: any }) {
    if (this.environment?.env === 'development') {
      console.warn(message)
    }
    if (!this.shouldLog()) {
      return false
    }

    return await this.log(message, 'warn')
  }
}
